import React from "react";
import ProjetoLayout from "../componentes/ProjetoLayout";

function DiarioMotorista() {
  return (
    <ProjetoLayout
      titulo="Diário do Motorista"
      tagline="Sistema web completo para motoristas de caminhão controlarem viagens, rotas e despesas de forma centralizada."
      liveUrl="https://diariodebordopx.vercel.app/login"
      capa="/capa-diario-motorista.png"
      capaAlt="Diário do Motorista"
      tags={[
        "React",
        "Next.js",
        "PrimeReact",
        "Firebase",
        "FireAuth",
        "JavaScript",
      ]}
      meta={[
        { ic: "code", label: "Tipo", value: "Full-stack" },
        { ic: "role", label: "Papel", value: "Desenvolvedor" },
        { ic: "local", label: "Status", value: "No ar" },
      ]}
    >
      <h2>Gestão para caminhoneiros</h2>
      <p>
        O <strong>Diário do Motorista</strong> é um sistema web completo,
        desenvolvido para dar a motoristas de caminhão uma ferramenta{" "}
        <strong>prática e centralizada</strong> para o controle total das viagens.
        O objetivo foi simplificar a rotina do caminhoneiro com registro detalhado
        de rotas, gestão de despesas e um histórico consolidado de trabalho.
      </p>
      <p>
        A plataforma foi construída com foco na usabilidade, com uma{" "}
        <strong>interface moderna, intuitiva e responsiva</strong> e feedbacks
        visuais (como toasts) para uma experiência fluida.
      </p>

      <h3>Principais funcionalidades</h3>
      <ul>
        <li>
          <strong>Autenticação segura:</strong> cadastro e login por e-mail e
          senha, garantindo privacidade dos dados de cada motorista.
        </li>
        <li>
          <strong>Gestão completa de viagens:</strong> cadastro com origem,
          destino, data, quilometragem e tipo de carga; acompanhamento e
          finalização de rotas com cálculos automáticos de distância e duração.
        </li>
        <li>
          <strong>Controle de despesas:</strong> registro de gastos (combustível,
          alimentação etc.) vinculados a cada viagem.
        </li>
        <li>
          <strong>Histórico e resumos:</strong> dashboard com total de viagens, km
          rodados e tempo total de trabalho.
        </li>
      </ul>
    </ProjetoLayout>
  );
}

export default DiarioMotorista;
